module.exports = __webpack_public_path__ + "static/media/14UNEP17.56728469.jpg";